function setFormNotSubmitting({ state }) {
  state.set('client.forms.isSubmitting', false)
}

export default setFormNotSubmitting



// WEBPACK FOOTER //
// ./src/modules/user/actions/setFormNotSubmitting.js